module.exports = __webpack_public_path__ + "img/Cintillo BPX.d04091be.png";